import { call, put, select, takeLatest } from 'redux-saga/effects'
import { BillingConstants } from '../../billing/store/billing.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { setRelationshipsAndGuarantorsState } from '../store/relationshipsAndGuarantors.action'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'

export function* getRelationshipsAndGuarantors(pcrDoc: IPcr) {
  const relationshipsAndGuarantors = pcrDoc.billing?.relationshipsAndGuarantors
  if (relationshipsAndGuarantors && Object.keys(relationshipsAndGuarantors).length !== 0) {
    yield put(setRelationshipsAndGuarantorsState(relationshipsAndGuarantors))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(getRelationshipsAndGuarantors, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in getRelationshipsAndGuarantors.saga.ts: ${e}`))
  }
}

export function* getRelationshipsAndGuarantorsSaga() {
  yield takeLatest([BillingConstants.REFRESH_BILLING_DATA], performWithMutexHOG, preloadPCR)
}
